import { DataPointModel } from '../interfaces';

export default class DataPoint {
  public askPosition!: DataPointModel;

  public bidPosition!: DataPointModel;

  public lastVisibleAsk!: DataPointModel;

  public lastVisibleBid!: DataPointModel;

  public isInsideCanvas = false;

  public update([askPosition, bidPosition]: [DataPointModel, DataPointModel]) {
    this.askPosition = askPosition;
    this.bidPosition = bidPosition;
  }

  public updateLastVisible([lastVisibleAsk, lastVisibleBid]: [DataPointModel, DataPointModel]) {
    this.lastVisibleAsk = lastVisibleAsk;
    this.lastVisibleBid = lastVisibleBid;
  }

  public insideCanvas(bool: boolean): void {
    this.isInsideCanvas = bool;
  }
}
